module.exports = __webpack_public_path__ + "static/media/cbahostlogo.fafbff5c.jpg";